// extracted by mini-css-extract-plugin
module.exports = {"page":"detail_page__1prQQ","mailPreview":"detail_mailPreview__ZgxXj"};